export default "__VITE_ASSET__Jnk54Zzr__"